const cardTestIDs = {
  // Card
  cardTitle: 'card-title',
  cardMainValue: 'card-main-value',
  cardProjectedThisMonthValue: 'card-projected-this-month-value',
  cardSameLastMonthValue: 'card-same-last-month-value',
  cardLastMonthTotalValue: 'card-last-month-total-value',
  cardProjectedThisMonthTitle: 'card-projected-this-month-title',
  cardSameLastMonthTitle: 'card-same-last-month-title',
  cardLastMonthTotalTitle: 'card-last-month-total-title',

  cardNewFrontlineClientsTitle: 'card-new-frontline-clients-title',
  cardAllFrontlineClientsTitle: 'card-all-frontline-clients-title',
  cardNewGen0ClientsTitle: 'card-new-gen0-clients-title',
  cardTotalGen0ClientsTitle: 'card-total-gen0-clients-title',
  cardNewTGenClientsTitle: 'card-new-tgen-clients-title',
  cardAllTGenClientsTitle: 'card-all-tgen-clients-title',
  cardReactivatedTGenTitle: 'card-reactivated-tgen-title',
  cardReactivatedFrontlineTitle: 'card-reactivated-frontline-title',

  cardNewFrontlineClientsValue: 'card-new-frontline-clients-value',
  cardAllFrontlineClientsValue: 'card-all-frontline-clients-value',
  cardNewGen0ClientsValue: 'card-new-gen0-clients-value',
  cardTotalGen0ClientsValue: 'card-total-gen0-clients-value',
  cardNewTGenClientsValue: 'card-new-tgen-clients-value',
  cardAllTGenClientsValue: 'card-all-tgen-clients-value',
  cardReactivatedTGenValue: 'card-reactivated-tgen-value',
  cardReactivatedFrontlineValue: 'card-reactivated-frontline-value',

  cardAllClientsDeltaValue: 'card-all-clients-delta-value',

  cardCurrentFrontlineVolumeTitle: 'card-current-frontline-volume-title',
  cardProjectedFrontlineVolumeTitle: 'card-projected-frontline-volume-title',
  cardTotalFrontlineVolumeTitle: 'card-total-frontline-volume-title',
  cardCurrentGen0VolumeTitle: 'card-current-gen0-volume-title',
  cardProjectedGen0VolumeTitle: 'card-projected-gen0-volume-title',
  cardTotalGen0VolumeTitle: 'card-total-gen0-volume-title',
  cardCurrentTGenVolumeTitle: 'card-current-tgen-volume-title',
  cardProjectedTGenVolumeTitle: 'card-projected-tgen-volume-title',
  cardTotalTGenVolumeTitle: 'card-total-tgen-volume-title',

  cardCurrentFrontlineVolumeValue: 'card-current-frontline-volume-value',
  cardProjectedFrontlineVolumeValue: 'card-projected-frontline-volume-value',
  cardTotalFrontlineVolumeValue: 'card-total-frontline-volume-value',
  cardCurrentGen0VolumeValue: 'card-current-gen0-volume-value',
  cardProjectedGen0VolumeValue: 'card-projected-gen0-volume-value',
  cardTotalGen0VolumeValue: 'card-total-gen0-volume-value',
  cardCurrentTGenVolumeValue: 'card-current-tgen-volume-value',
  cardProjectedTGenVolumeValue: 'card-projected-tgen-volume-value',
  cardTotalTGenVolumeValue: 'card-total-tgen-volume-value',

  cardNewFrontlineCoachesTitle: 'card-new-frontline-coaches-title',
  cardNewGen0CoachesTitle: 'card-new-gen0-coaches-title',
  cardNewOrganizationCoachesTitle: 'card-new-organization-coaches-title',
  cardSeniorCoachTeamsTitle: 'card-senior-coach-teams-title',
  cardExecutiveDirectorTeamsTitle: 'card-executive-director-teams-title',
  cardFIBCTeamsTitle: 'card-FIBC-teams-title',

  cardNewFrontlineCoachesValue: 'card-new-frontline-coaches-value',
  cardNewGen0CoachesValue: 'card-new-gen0-coaches-value',
  cardNewOrganizationCoachesValue: 'card-new-organization-coaches-value',
  cardSeniorCoachTeamsValue: 'card-senior-coach-teams-value',
  cardExecutiveDirectorTeamsValue: 'card-executive-director-teams-value',
  cardFIBCTeamsValue: 'card-FIBC-teams-value',

  cardFrontlineQualifyingVolumeTitle: 'card-frontline-qualifying-volume-title',
  cardProjectedFQVTitle: 'card-projected-FQV-title',
  cardGeneration0VolumeTitle: 'card-generation-0-volume-title',
  cardTotalGenerationVolumeTitle: 'card-total-generation-volume-title',
  cardSameLastMonth1Title: 'card-same-last-month-1-title',
  cardSameLastMonth2Title: 'card-same-last-month-2-title',

  cardFrontlineQualifyingVolumeValue: 'card-frontline-qualifying-volume-value',
  cardProjectedFQVValue: 'card-projected-FQV-value',
  cardGeneration0VolumeValue: 'card-generation-0-volume-value',
  cardTotalGenerationVolumeValue: 'card-total-generation-volume-value',

  cardSameLastMonth1Value: 'card-same-last-month-1-value',
  cardSameLastMonthDelta1Value: 'card-same-last-month-delta-1-value',
  cardSameLastMonth2Value: 'card-same-last-month-2-value',
  cardSameLastMonthDelta2Value: 'card-same-last-month-delta-2-value',

  // Cards
  FQVCard: 'FQV-card',
  G0VCard: 'G0V-card',
  TGVCard: 'TGV-card',
  clientsSummaryCard: 'clients-summary-card',
  clientsSummaryCardTitle: 'clients-summary-card-title',
  ordersSummaryCard: 'orders-summary-card',
  ordersSummaryCardTitle: 'orders-summary-card-title',
  coachesTeamsSummaryCard: 'coaches-teams-summary-card',
  coachesTeamsSummaryCardTitle: 'coaches-teams-summary-card-title',
  teamVolumesSummaryCard: 'team-volumes-summary-card',
  teamVolumesSummaryCardTitle: 'team-volumes-summary-card-title',

  cardListItem: 'card-list-item',
};

export default cardTestIDs;
